import { api } from 'app/config/apiConfig';
import { User } from 'entities/User';
import { ChargeBalanceParams } from '../model/types';

export const chargeBalanceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    chargeBalance: builder.mutation<User, { userId: string; params: ChargeBalanceParams }>({
      query: ({ userId, params }) => ({
        url: `/users/${userId}/balance/charge`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Users', 'User balance actions'],
    }),
  }),
});

export const { useChargeBalanceMutation } = chargeBalanceApi;
